import gql from "graphql-tag";

export const GET_HISTORIES = gql`
  query histories($sort: String) {
    histories(sort: $sort) {
      id
      year
      detail {
        id
        text
        history_date
      }
    }
  }
`;
